import { render, staticRenderFns } from "./approveconfirmpaymentorder.vue?vue&type=template&id=dfe1f5ce&scoped=true&"
import script from "./approveconfirmpaymentorder.vue?vue&type=script&lang=js&"
export * from "./approveconfirmpaymentorder.vue?vue&type=script&lang=js&"
import style0 from "./approveconfirmpaymentorder.vue?vue&type=style&index=0&id=dfe1f5ce&scoped=true&lang=css&"
import style1 from "./approveconfirmpaymentorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe1f5ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VChip,VCombobox,VContainer,VDataTable,VFlex,VLayout,VTextField})
